import React from "react";
import Sel from "react-select";

function MultiSelect({
  name,
  options,
  value,
  label,
  onChange,
  error = null,
  title = null,
  ...rest
}) {
  options = options || [];
  // options is [{id, name}]
  // value is [id, id...]
  const reoptions = options.map((o) => {
    return { value: o.id, label: o.name };
  });
  const revalue = reoptions.filter((ro) => value?.includes?.(ro.value)) || null;
  // undefined doesn't clear the native react select below, it needs to be NULL

  return (
    <div className={"field"} title={title}>
      <label className={"label"}>{label}</label>
      <div className={"control"}>
        <Sel
          isMulti
          isClearable={true}
          isSearchable={true}
          options={reoptions}
          value={revalue}
          onChange={(a) => {
            // console.log(name, a);
            onChange(name, a?.map((item) => item.value) || null);
          }}
          onClear={(a) => console.log("cleared?", a)}
          {...rest}
        />
      </div>
      {error ? <p className={"help is-danger"}>{error}</p> : null}
    </div>
  );
}

export default MultiSelect;
